<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12" sm="10">
                <v-row>
                    <v-col cols="12" class="mb-3">
                        <h3 v-text="$t('einstellungen.basis.title')" />
                    </v-col>
                </v-row>

                <v-row class="pb-5">
                    <!-- Teilnehmer Label -->
                    <v-col cols="12" sm="2" class="d-flex align-items-center text-nowrap">
                        {{ $t('einstellungen.basis.teilnehmer') }}
                    </v-col>

                    <!-- KundenDaten Info -->
                    <v-col cols="12" sm="4">
                        <div class="mb-1">{{ kundenDaten.firma }}</div>
                        <div class="mb-1">
                            {{ kundenDaten.strasse + (kundenDaten.hausNummer ? ' ' + kundenDaten.hausNummer : '') }}
                        </div>
                        <div>{{ kundenDaten.plz + ' ' + kundenDaten.ort }}</div>
                    </v-col>

                    <!-- Additional Details -->
                    <v-col cols="12" sm="6">
                        <v-row>
                            <v-col cols="4" class="py-0 text-nowrap">
                                {{ $t('einstellungen.basis.teilnehmernummer') }}
                            </v-col>
                            <v-col cols="8" class="py-0">
                                <span v-if="kundenDaten.teilnehmerStatus">
                                    {{ kundenDaten.kundenNummer + ' (' + $t('einstellungen.basis.active') + ' ' + kundenDaten.ersteAktivierungAm + ')' }}
                                </span>
                                <span v-else>
                                    {{ kundenDaten.kundenNummer + ' (' + $t('einstellungen.basis.inaktiv') + ')' }}
                                </span>
                            </v-col>
                            <v-col cols="4" class="py-0 text-nowrap">
                                {{ $t('einstellungen.basis.telefon') }}
                            </v-col>
                            <v-col cols="8" class="py-0">
                                {{ kundenDaten.telefon }}
                            </v-col>
                            <v-col cols="4" class="py-0 text-nowrap">
                                {{ $t('einstellungen.basis.email') }}
                            </v-col>
                            <v-col cols="8" class="py-0">
                                {{ kundenDaten.email }}
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>

                <v-row>
                    <!-- Edit Address Dialog -->
                    <v-col cols="auto">
                        <EditAdresseDialog :edit-teilnehmer="kundenDaten" @success="$emit('success')" />
                    </v-col>
                    <!-- Modifications Information -->
                    <v-col>
                        <p v-if="kundenDaten.istMutiertInVetdata" class="font-italic font-weight-thin mb-0">
                            <v-icon color="primary" size="small">mdi-information</v-icon>
                            {{ $t('einstellungen.basis.modifiziert') }}
                        </p>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-facing-decorator';
import { TeilnehmerApiDto } from '@/api-schema';

import EditAdresseDialog from './EditAdresseDialog.vue';
@Component({
    components: {
        EditAdresseDialog
    }
})
export default class BasisEinstellungen extends Vue {
    @Prop({ required: true, type: Object })
    private kundenDaten!: TeilnehmerApiDto;
}
</script>

<style scoped>
.no-wrap {
    white-space: nowrap;
}
</style>
